import { render, staticRenderFns } from "./PagePlanograms.vue?vue&type=template&id=baca9d84&"
import script from "./PagePlanograms.vue?vue&type=script&lang=js&"
export * from "./PagePlanograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports